import { render } from "./DateComponent.vue?vue&type=template&id=69cddeb4&scoped=true"
import script from "./DateComponent.vue?vue&type=script&lang=js"
export * from "./DateComponent.vue?vue&type=script&lang=js"

import "./DateComponent.vue?vue&type=style&index=0&id=69cddeb4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69cddeb4"]])

export default __exports__